import React, { useState } from "react"
import SustainabilityHeader from "./SustainabilityHeader/SustainabilityHeader"
import SustainabilityInfo from "./SustainabilityInfo/SustainabilityInfo"
import SustainabilityCircular from "./SustainabilityCircular/SustainabilityCircular"
import SustainabilityJourney from "./SustainabilityJourney/SustainabilityJourney"
import { default as TopBackgroundImage } from "../../images/eco-sustainability_bg-5.svg"
import { default as BottomBackgroundImage } from "../../images/eco-sustainability_bg-3.svg"

import * as styles from "./Sustainability.module.scss"

const Sustainability = ({ productType: product }) => {
  const [productType, setProductType] = useState(product || "Compostable")
  let videoURL = `https://videos.ctfassets.net/xmruv773lc7r/I0VB31kjcx1l6YMcstBxe/a476ba792f1d5675762393f4251f3f28/02_Compostable_NewEdit.mp4`
  let placeholderURL = 'https://images.ctfassets.net/xmruv773lc7r/6PQz6eSGsAT3Veua8aXTV5/7f1077112e6ca41a3584bc20559c94bd/compostable.jpg?w=1920fm=avif';

  if (productType === "Recycle") {
    videoURL = `https://videos.ctfassets.net/xmruv773lc7r/5MwKBH8yvWYbmeooy8TOD6/c5a21076cbb190882c32c1efc369da38/01_Recyclable.mp4`
    placeholderURL = 'https://images.ctfassets.net/xmruv773lc7r/5MgJKF5YeZWbMIm6U4DoPQ/7da8582cc9e686b8b351d38de938b124/recyclable.jpg?w=1920&fm=avif'
  } else if (productType === "Reusable") {
    videoURL = `https://videos.ctfassets.net/xmruv773lc7r/5WlLHa7MNMcnooPyN8ejhO/4bf27a9b82af669521257c4f0f01533b/03_Reusable_NewEdit.mp4`
    placeholderURL = 'https://images.ctfassets.net/xmruv773lc7r/3H0X8Lz1pyaQpMYfNo7yfY/d2cc00e3ffa396e52c964651d926b985/reusable.jpg?w=1920&q=75&fm=avif'
  }

  return (
    <div className={styles.sustainabilityContainer}>
      <video
        className={styles.headerVideo}
        src={videoURL}
        poster={placeholderURL}
        autoPlay
        playsInline
        muted
        loop
      />
      <div className="sustainability-page">
        <div className={styles.headerWrapper}>
          <SustainabilityHeader
            productType={productType}
            getSelectedProduct={item => setProductType(item)}
          />
          <SustainabilityInfo productType={productType} />
        </div>
        <img
          src={TopBackgroundImage}
          className={styles.topBackgroundImage}
          alt="top-backgound"
          loading="lazy"
        ></img>
        <div className={styles.circularJourneyWrapper}>
          <SustainabilityCircular productType={productType} />
        </div>
        <div className={styles.bottomBackgroundImageContainer}>
          <img
            src={BottomBackgroundImage}
            className={styles.bottomBackgroundImage}
            alt="top-backgound"
            loading="lazy"
          ></img>
        </div>
        <SustainabilityJourney productType={productType} />
      </div>
    </div>
  )
}

export default Sustainability
